<template>
  <div class="homeview"> 
    <HeroSlider />

    <div class="about">
      <div class="container">
        <div class="row row-lg-eq-height">
          
          <!-- About Content -->
          <div class="col-lg-7">
            <div class="about_content">
              <div class="section_title"><h2>Highly Qualified and Trained</h2></div>
              <div class="about_text">
                <p>All our caregivers pass extensive background and reference checks. We ensure they have the necessary qualifications and training for their roles. Many also hold additional certifications in first aid, dementia care, or palliative care.</p>
              </div>
              <div class="button about_button">
                <router-link to="/about">read more</router-link>
              </div>
            </div>
          </div>

          <!-- About Image -->
          <div class="col-lg-5">
            <div class="about_image"><img src="../assets/img/about2.jpg" alt=""></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Departments -->
    <div class="departments">
      <div class="departments_background parallax-window" data-parallax="scroll" data-image-src="../assets/img/departments.jpg" data-speed="0.8"></div>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="section_title section_title_light"><h2>What we offer</h2></div>
          </div>
        </div>
        <div class="row departments_row row-md-eq-height">
          
          <!-- Department -->
          <div class="col-lg-3 col-md-6 dept_col">
            <div class="dept">
              <div class="dept_image"><img src="../assets/img/about4.jpg" alt=""></div>
              <div class="dept_content text-center">
                <div class="dept_title">Caregiver Matching</div>
                <div class="dept_subtitle">We use our extensive database of qualified caregivers to find the best fit.</div>
              </div>
            </div>
          </div>

          <!-- Department -->
          <div class="col-lg-3 col-md-6 dept_col">
            <div class="dept">
              <div class="dept_image"><img src="../assets/img/dept_2.jpg" alt=""></div>
              <div class="dept_content text-center">
                <div class="dept_title">Detailed Profiles</div>
                <div class="dept_subtitle">You'll receive comprehensive profiles of caregivers, including their qualifications and experience.</div>
              </div>
            </div>
          </div>

          <!-- Department -->
          <div class="col-lg-3 col-md-6 dept_col">
            <div class="dept">
              <div class="dept_image"><img src="../assets/img/about5.jpg" alt=""></div>
              <div class="dept_content text-center">
                <div class="dept_title">Meet and Greet</div>
                <div class="dept_subtitle">We arrange in-person meet and greets to ensure you and your loved one feel comfortable with the caregiver.</div>
              </div>
            </div>
          </div>
          
          <!-- Department -->
          <div class="col-lg-3 col-md-6 dept_col">
            <div class="dept">
              <div class="dept_image"><img src="../assets/img/dept_3.jpg" alt=""></div>
              <div class="dept_content text-center">
                <div class="dept_title">Consultation</div>
                <div class="dept_subtitle">We'll learn about your loved one's daily needs, medical conditions, personality and interests
  </div>
              </div>
            </div>
          </div>

          <!-- Department -->
          
        </div>
      </div>
    </div>

    <!-- Services -->

    <div class="services">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="section_title"><h2>Valuing Diversity:</h2></div>
          </div>
          We recognize that cultural competency is essential for providing respectful and sensitive care. We aim to match caregivers with similar cultural backgrounds or language skills to your loved one whenever possible, fostering trust, rapport, and comfort.
          <p>We offer a wide range of caregivers to meet your specific needs.</p>
        </div>
        <div class="row services_row">
          
          <!-- Service -->
          <div class="col-lg-4 col-md-6 service_col">
            
              <div class="service text-center trans_200">
                <div class="service_icon"><img class="svg" src="../assets/img/service_1.svg" alt=""></div>
                <div class="service_title trans_200">Elderly Caregivers</div>
                <div class="service_text">
                  <p>Experienced in helping aged people with daily tasks, managing medications, and offering companionship.</p>
                </div>
              </div>
            
          </div>

          <!-- Service -->
          <div class="col-lg-4 col-md-6 service_col">
            
              <div class="service text-center trans_200">
                <div class="service_icon"><img class="svg" src="../assets/img/service_2.svg" alt=""></div>
                <div class="service_title trans_200">Dementia Caregivers</div>
                <div class="service_text">
                  <p>Equipped with specialized skills to deliver compassionate care for individuals with dementia, ensuring their safety and creating a calming environment.</p>
                </div>
              </div>
            
          </div>

          <!-- Service -->
          <div class="col-lg-4 col-md-6 service_col">
            
              <div class="service text-center trans_200">
                <div class="service_icon"><img class="svg" src="../assets/img/service_3.svg" alt=""></div>
                <div class="service_title trans_200">Disability Support Specialists</div>
                <div class="service_text">
                  <p>Dedicated to helping individuals with disabilities with everyday tasks, getting around, and living more independently.</p>
                </div>
              </div>
            
          </div>

          <!-- Service -->
          <div class="col-lg-4 col-md-6 service_col">
            
              <div class="service text-center trans_200">
                <div class="service_icon"><img class="svg" src="../assets/img/service_4.svg" alt=""></div>
                <div class="service_title trans_200">Live-in Caregivers</div>
                <div class="service_text">
                  <p>Deliver round-the-clock care and become a part of your family for those who need constant assistance.</p>
                </div>
              </div>
            
          </div>

          <!-- Service -->
          <div class="col-lg-4 col-md-6 service_col">
            
              <div class="service text-center trans_200">
                <div class="service_icon"><img class="svg" src="../assets/img/service_5.svg" alt=""></div>
                <div class="service_title trans_200">Pediatric care</div>
                <div class="service_text">
                  <p>Pediatric care: We offer comprehensive medical care for infants, children, and adolescents, ensuring their health and well-being.</p>
                </div>
              </div>
            
          </div>

          <!-- Service -->
          
        </div>
      </div>
    </div>

    <!-- Benefits -->
    
    <div class="team">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="section_title"><h2>Benefits of Working with Secured Homecare</h2></div>
          </div>
        </div>
        
        <div class="row team_row">
          
          <!-- Team Member -->
          <div class="col-lg-3 team_col">
            <div class="team_member">
              <div class="team_member_image d-flex flex-column align-items-center justify-content-end"><img src="" alt=""></div>
              <div class="team_member_info">
                <div class="team_member_name"><font color="#1A08FB">Training and development</font></div>
                <div class="team_member_title">We invest in ongoing training and development of our employees. Employees recieves comprehensive training in areas such as patient care techniques, safety protocols, communication skills, and specialized care for conditions like dementia or palliative care.</div>
              </div>
            </div>
          </div>

          <!-- Team Member -->
          <div class="col-lg-3 team_col">
            <div class="team_member">
              <div class="team_member_image d-flex flex-column align-items-center justify-content-end"><img src="" alt=""></div>
              <div class="team_member_info">
                <div class="team_member_name"><font color="#1A08FB">Professional Growth</font></div>
                <div class="team_member_title">Opportunities exist to climb the ladder within the company, pursuing certifications, specialized training, and leadership roles.</div>
              </div>
            </div>
          </div>

          <!-- Team Member -->
          <div class="col-lg-3 team_col">
            <div class="team_member">
              <div class="team_member_image d-flex flex-column align-items-center justify-content-end"><img src="" alt=""></div>
              <div class="team_member_info">
                <div class="team_member_name"><font color="#1A08FB">Competitive Pay and Perks</font></div>
                <div class="team_member_title">The dedication and expertise of our workers are valued. Expect competitive salaries and benefits packages that include health insurance, retirement plans, and time off.</div>
              </div>
            </div>
          </div>

          <!-- Team Member -->
          <div class="col-lg-3 team_col">
            <div class="team_member">
              <div class="team_member_image d-flex flex-column align-items-center justify-content-end"><img src="" alt=""></div>
              <div class="team_member_info">
                <div class="team_member_name"><font color="#1A08FB">Flexible Working Hours</font></div>
                <div class="team_member_title">We offer flexible scheduling, allowing caregivers to manage work-life balance and personal commitments.</div>
              </div>
            </div>
          </div>
          

          <!-- Team Member -->
          
          <div class="col-lg-3 team_col">
            <div class="team_member">
              <div class="team_member_image d-flex flex-column align-items-center justify-content-end"><img src="" alt=""></div>
              <div class="team_member_info">
                <div class="team_member_name"><font color="#1A08FB">Supportive Team Atmosphere</font></div>
                <div class="team_member_title">Our workers aren't alone. We foster a collaborative environment with supportive colleagues and supervisors who provide guidance and recognition.</div>
              </div>
            </div>
          </div>
          
          <!-- Team Member -->
          <div class="col-lg-3 team_col">
            <div class="team_member">
              <div class="team_member_image d-flex flex-column align-items-center justify-content-end"><img src="" alt=""></div>
              <div class="team_member_info">
                <div class="team_member_name"><font color="#1A08FB">Feel Valued and Appreciated</font></div>
                <div class="team_member_title">Hard work and dedication are celebrated! Rewards, bonuses, and recognition programs acknowledge the valuable contributions of our workers.</div>
              </div>
            </div>
          </div>
          <!-- Team Member -->
          <div class="col-lg-3 team_col">
            <div class="team_member">
              <div class="team_member_image d-flex flex-column align-items-center justify-content-end"><img src="" alt=""></div>
              <div class="team_member_info">
                <div class="team_member_name"><font color="#1A08FB">Health and Wellness Benefits</font></div>
                <div class="team_member_title">Your well-being matters. We may offer health and wellness benefits like insurance and programs promoting physical and mental health.</div>
              </div>
            </div>
          </div>
          <!-- Team Member -->
          <div class="col-lg-3 team_col">
            <div class="team_member">
              <div class="team_member_image d-flex flex-column align-items-center justify-content-end"><img src="" alt=""></div>
              <div class="team_member_info">
                <div class="team_member_name"><font color="#1A08FB">Stable and Secured Future</font></div>
                <div class="team_member_title">We provide job stability and security, with consistent work opportunities and the assurance of being part of a growing and essential industry.</div>
                <p>&nbsp;</p>
              </div>
            </div>
          </div>
          
          
        </div>
      </div>
    </div>
    
    <!-- Call to action -->

    <div class="cta">
      <div class="cta_background parallax-window" data-parallax="scroll" data-image-src="../assets/img/cta.jpg" data-speed="0.8"></div>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="cta_content text-center">
              <h2>Need a personal Caregiver?</h2>
              <p></p>
              <div class="button cta_button"><router-link to="/contact">Request one now</router-link></div>
            </div>
          </div>
        </div>
      </div>		
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeroSlider from '@/components/HeroSlider.vue'

export default {
  name: 'HomeView',
  components: {
    HeroSlider
  }
}
</script>
<style scoped>
.cta_background {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.cta_background::before {
    content: "";
    position: absolute;
    inset: 0;
    background: url("../assets/img/cta.jpg") center/cover no-repeat;
    will-change: transform;
    z-index: -1;
}

.departments_background {
  position: absolute;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.departments_background::before {
  content: "";
  position: absolute;
  inset: -20%;
  background: url('../assets/img/departments.jpg') center/cover no-repeat;
  transform: translateZ(0) scale(1.2);
  will-change: transform;
  z-index: -1;
}
</style>